import { render } from "./FormPromo.vue?vue&type=template&id=44bc7519&scoped=true"
import script from "./FormPromo.vue?vue&type=script&lang=js"
export * from "./FormPromo.vue?vue&type=script&lang=js"

import "./FormPromo.vue?vue&type=style&index=0&id=44bc7519&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bc7519"]])

export default __exports__